module.exports = __webpack_public_path__ + "static/media/drdiary_02.c5df390c.png";